import React from "react"

import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"

const ResourceCTA = ({ content }) => {
  return (
    <Wrapper>
      {content?.body && (
        <Body dangerouslySetInnerHTML={{ __html: content?.body }} />
      )}
      {content?.subCopy && (
        <SubCopy dangerouslySetInnerHTML={{ __html: content?.subCopy }} />
      )}
    </Wrapper>
  )
}

const SubCopy = styled.p`
  ${text.bodyMd};

  ${media.fullWidth} {
  }

  ${media.tablet} {
    ${text.bodySm};
  }

  ${media.mobile} {
    ${text.bodySm};
  }
`
const Body = styled.p`
  ${text.bodyMd};
  h5 {
    ${text.h5};

    ${media.mobile} {
      ${text.h4};
    }
  }

  h4 {
    ${text.h4};
    text-indent: -1.042vw;

    ${media.fullWidth} {
      text-indent: -15px;
    }

    ${media.tablet} {
      ${text.h5};
      text-indent: -1.465vw;
    }

    ${media.mobile} {
      ${text.h4};
      text-indent: -2vw;
    }
  }

  a {
    color: ${colors.primaryOrange};
  }
`
const Wrapper = styled.div`
  background-color: ${colors.lightPurpleGrey};
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 1.111vw;
  gap: 1.389vw;
  width: 79.444vw;
  padding: 2.778vw;

  ${media.fullWidth} {
    border-radius: 16px;
    gap: 20px;
    width: 1144px;
    padding: 40px;
  }

  ${media.tablet} {
    border-radius: 1.563vw;
    gap: 1.953vw;
    width: 92.188vw;
    padding: 3.906vw;
  }

  ${media.mobile} {
    border-radius: 3.738vw;
    gap: 4.673vw;
    width: 85.981vw;
    padding: 9.346vw;
  }
`
export default ResourceCTA
